import React, { useState } from "react";
import { Modal } from "rsuite";
import { DataInput, Button } from "../../../components";
import ToastService from "../../../services/toast.service";
import CentresService from "../centres.service";
import logger from "../../../utils/logger";

function CreateCentreModal({ open, onClose, onSave }) {
  const [formData, setFormData] = useState({
    swnNumber: "",
    centreName: "",
    eceNumber: "",
    costCodeAlpha: ""
  });
  const [loading, setLoading] = useState(false);

  // Format SWN number: only digits, max 9, dashes after every 3 digits
  const formatSwnNumber = (value) => {
    const numbers = value.replace(/\D/g, '').slice(0, 9);
    let formatted = '';
    for (let i = 0; i < numbers.length; i++) {
      if (i > 0 && i % 3 === 0) {
        formatted += '-';
      }
      formatted += numbers[i];
    }
    return formatted;
  };

  const handleInputChange = (field, value) => {
    if (field === 'swnNumber') {
      value = formatSwnNumber(value);
    }
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const validateForm = () => {
    if (!formData.swnNumber || !formData.centreName || !formData.eceNumber) {
      ToastService.error("Please fill in all required fields");
      return false;
    }
    // Validate SWN: must be 9 digits (with or without dashes)
    const digits = formData.swnNumber.replace(/\D/g, '');
    if (digits.length !== 9) {
      ToastService.error("SWN Number must be 9 digits");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;  
    setLoading(true);
    try {
      await CentresService.createCentre({
        swnNumber: formData.swnNumber,
        centreName: formData.centreName,
        eceNumber: formData.eceNumber,
        costCodeAlpha: formData.costCodeAlpha
      });
      ToastService.success("Centre created successfully");
      if (onSave) onSave(formData);
      setFormData({ swnNumber: "", centreName: "", eceNumber: "", costCodeAlpha: "" });
      onClose();
    } catch (error) {
      logger.error("Error creating centre:", error);
      ToastService.error(`Failed to create centre: ${error.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({ swnNumber: "", centreName: "", eceNumber: "" });
    onClose();
  };

  return (
    <Modal open={open} onClose={handleCancel} size="md">
      <Modal.Header>
        <Modal.Title>Create Centre</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="create-centre-container">
          <DataInput
            label="SWN Number"
            placeholder="000-000-000"
            value={formData.swnNumber}
            onChange={e => handleInputChange("swnNumber", e.target.value)}
          />
          <DataInput
            label="Centre Name"
            placeholder="Enter Centre Name"
            value={formData.centreName}
            onChange={e => handleInputChange("centreName", e.target.value)}
          />
          <DataInput
            label="ECE Number"
            placeholder="Enter ECE Number"
            value={formData.eceNumber}
            onChange={e => handleInputChange("eceNumber", e.target.value)}
          />
           <DataInput
            label="Cost Code Alpha"
            placeholder="Enter Cost Code Alpha"
            value={formData.costCodeAlpha}
            onChange={e => handleInputChange("costCodeAlpha", e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleSubmit}
          appearance="primary"
          loading={loading}
          disabled={loading}
          text="Create"
         />
        <Button
          onClick={handleCancel}
          appearance="subtle"
          disabled={loading}
          color="blue"
          text="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
}

export default CreateCentreModal;
